export var listStyle = {
    topBar: {
        height: 70,
        paddingLeft: 1,
        paddingRight: 1
    },
    searchHolder: {
        position: 'relative',
        marginRight: '20px',
        width: 300
    },
    search: {
        width: '100%',
        paddingRight: '20px'
    },
    searchLoader: {
        position: 'absolute',
        right: 30
    },
    header: {
        height: 38,
        background: '#f3f2f7',
        borderBottom: '1px solid #F3F2F7'
    },
    headerText: {
        fontSize: 12,
        color: '#6e6b7b'
    },
    row: {
        position: 'relative',
        minHeight: 51,
        minWidth: 'fit-content',
        width: '100%',
        borderBottom: '1px solid #f0f0f0',
    },
    cell: {
        paddingLeft: '10px',
        width: 100,
        minWidth: 100,
        height: '100%',
        cursor: 'pointer',
    },
    cellXS: {
        width: 50,
        minWidth: 50
    },
    cellS: {
        width: 75,
        minWidth: 75,
    },
    cellM: {
        width: 100,
        minWidth: 100,
    },
    cellL: {
        width: 150,
        minWidth: 150,
    },
    cellLG: {
        width: 175,
        minWidth: 175,
    },
    cellXL: {
        width: 200,
        minWidth: 200,
    },
    cellXXL: {
        width: 300,
        minWidth: 300,
    },
    cellXXXL: {
        width: 400,
        minWidth: 400,
    },
    cellGrow: {
        width: 'unset',
        flex: 1,
        minWidth: 150
    },
    breadcrumbs: {
        marginTop: 4,
        marginBottom: 4,
    },
    actionButtonHolder: {
        marginLeft: 'auto'
    },
    avatar: {
        width: 32,
        height: 32,
        marginRight: 10,
        fontSize: 14
    },
    footer: {
        minHeight: 83,
        paddingTop: '16px',
        paddingBottom: '16px',
        paddingLeft: 1,
        paddingRight: 1
    },
    pageSize: {
        width: '140px'
    },
    loadingBox: {
        width: '100%',
        height: 100
    }
};
